import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { dataServiceBaseUrl, dataService } from "../endpoints";
// Define a service using a base URL and expected endpoints
export const responsibilityGroupService = createApi({
  reducerPath: "responsibilityGroupService",
  baseQuery: fetchBaseQuery({ baseUrl: dataServiceBaseUrl }),
  tagTypes: ["ResponsibilityGroup"],
  endpoints: (builder) => ({
    getAllResponsibilityGroups: builder.mutation({
      query(body) {
        return {
          url: `${dataService.responsibilityGroupController.getAllResponsibilityGroups}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        }
      }
    }),
    getAllResponsibilityGroupsWithSearch: builder.mutation({
      query(body) {
        return {
          url: `${dataService.responsibilityGroupController.getAllResponsibilityGroupsWithSearch}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        }
      }
    }),
    getResponsibilityGroupById: builder.mutation({
      query(body) {
        return {
          url: `${dataService.responsibilityGroupController.getResponsibilityGroupById}/${body.id}`,
          method: "GET",
          headers: { Authorization: `Bearer ${body.token}`},
        };
      },
    }),
    saveResponsibilityGroup: builder.mutation({
      query(body) {
        return {
          url: `${dataService.responsibilityGroupController.saveResponsibilityGroup}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        }
      }
    }),
    updateResponsibilityGroup: builder.mutation({
      query(body) {
        return {
          url: `${dataService.responsibilityGroupController.updateResponsibilityGroup}/${body.payload.id}`,
          method: 'PUT',
          headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        }
      }
    }),
    deleteResponsibilityGroupById: builder.mutation({
      query(body) {
        return {
          url: `${dataService.responsibilityGroupController.deleteResponsibilityGroupById}/${body.id}`,
          method: 'DELETE',
          headers: { Authorization: `Bearer ${body.token}`},
        }
      }
    }),
    findAllResponsibilityGroup: builder.mutation({
      query(body) {
        return {
          url: `${dataService.responsibilityGroupController.findAllResponsibilityGroup}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        }
      }
    }),
    bulkSaveResponsibilityGroup: builder.mutation({
      query(body) {
        return {
          url: `${dataService.responsibilityGroupController.bulkSaveResponsibilityGroup}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        }
      }
    }),
  }),
});
export const {
  useGetAllResponsibilityGroupsMutation,
  useGetAllResponsibilityGroupsWithSearchMutation,
  useGetResponsibilityGroupByIdMutation,
  useSaveResponsibilityGroupMutation,
  useUpdateResponsibilityGroupMutation,
  useDeleteResponsibilityGroupByIdMutation,
  useFindAllResponsibilityGroupMutation,
  useBulkSaveResponsibilityGroupMutation
} = responsibilityGroupService;
